
const ONETRUST_API_KEY = '10d3cbb1-27db-4519-8f61-82dbf2e99fc2'
const ONETRUST_ENABLED = true

function otreplace(tag, otclass) {
  const parent = tag.parentNode
  if (!parent) return
  const newElement = document.createElement('div')
  if (tag.id) newElement.setAttribute('id', tag.id)
  newElement.classList = tag.classList
  newElement.classList.add(otclass)
  newElement.innerHTML = tag.innerHTML
  parent.insertBefore(newElement, tag)
  parent.removeChild(tag)
}

function defineWrapper(payload = false) {
  if (!payload) return
  window.OptanonWrapper = () => {
    try {
      const logoEl = document.getElementsByClassName('ot-pc-logo')[0]
      const titleEl = document.getElementById('ot-pc-title')
      if (logoEl && titleEl) logoEl.insertAdjacentElement('afterend', titleEl)

      const replaceTags = (selector, otclass) => {
        const tags = [...document.querySelectorAll(selector)]
        tags.forEach(tag => otreplace(tag, otclass))
      }
      replaceTags('#onetrust-consent-sdk h2', 'ot-h2')
      replaceTags('#onetrust-consent-sdk h3', 'ot-h3')
      replaceTags('#onetrust-consent-sdk h4', 'ot-h4')
    } catch (e) {}
  }
}

function injectScript(tag) {
  document.head.insertBefore(tag, document.head.firstChild)
}

function alreadyInjected(id) {
  return !!document.getElementById(id)
}

export function loadOneTrust(payload = false) {
  defineWrapper(payload)
  if (!ONETRUST_ENABLED || alreadyInjected('oneTrust')) return
  const autoBlock = document.createElement('script')
  autoBlock.type = 'text/javascript'
  autoBlock.src = `https://cdn.cookielaw.org/consent/${ONETRUST_API_KEY}/OtAutoBlock.js`
  autoBlock.id = 'oneTrustAutoblock'
  injectScript(autoBlock)
  const sdk = document.createElement('script')
  sdk.id = 'oneTrust'
  sdk.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
  sdk.type = 'text/javascript'
  sdk.setAttribute('data-document-language', 'true')
  sdk.setAttribute('charset', 'UTF-8')
  sdk.setAttribute('data-domain-script', ONETRUST_API_KEY)
  injectScript(sdk)
}

export function loadOneTrustDenied(payload = false) { defineWrapper(payload) }

export function openConfigCookieModal() { if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') window.OneTrust.ToggleInfoDisplay() }

window.OneTrustHelper = { loadOneTrust, loadOneTrustDenied, openConfigCookieModal }
